import type { BoqPosition } from "./types";

export const PositionCard = ({ position }: { position: BoqPosition }) => {
  const lines = (position.description || "").split("\n");
  const mainDesc = lines[0];
  const details = lines.slice(1).join("\n").trim();

  return (
    <div className="bg-white rounded-xl border border-gray-200 p-4 hover:border-blue-200 hover:shadow-sm transition-all">
      <div className="flex items-start justify-between gap-3 mb-2">
        <span className="font-mono text-sm font-bold text-blue-600 bg-blue-50 px-2 py-0.5 rounded-md">
          {position.position_number || "—"}
        </span>
        <span className="font-mono text-sm font-semibold text-gray-800 bg-gray-100 px-2.5 py-0.5 rounded-md whitespace-nowrap">
          {position.quantity ?? "—"}{" "}
          <span className="text-gray-500 font-normal">
            {position.unit || ""}
          </span>
        </span>
      </div>
      <div className="text-sm text-gray-700 leading-relaxed">{mainDesc}</div>
      {details && (
        <div className="text-xs text-gray-500 mt-2 pl-3 border-l-2 border-gray-100 whitespace-pre-wrap leading-relaxed">
          {details}
        </div>
      )}
      {(position.section_name ||
        position.category ||
        position.manufacturer) && (
        <div className="flex flex-wrap gap-1.5 mt-3 pt-2.5 border-t border-gray-50">
          {position.section_name && (
            <span className="text-[10px] bg-gray-50 text-gray-500 px-2 py-0.5 rounded-full border border-gray-100">
              {position.section_name}
            </span>
          )}
          {position.category && (
            <span className="text-[10px] bg-gray-50 text-gray-500 px-2 py-0.5 rounded-full border border-gray-100">
              {position.category}
            </span>
          )}
          {position.manufacturer && (
            <span className="text-[10px] bg-indigo-50 text-indigo-600 px-2 py-0.5 rounded-full border border-indigo-100 font-mono">
              {position.manufacturer}
              {position.article_number && ` · ${position.article_number}`}
            </span>
          )}
        </div>
      )}
    </div>
  );
};
